import { CustomerRole } from '@npco/mp-gql-types'
import { useLoggedInUser } from '@npco/mp-utils-logged-in-user'

export const useIsInvoicingEnabled = (): boolean => {
  const { userData, userRole } = useLoggedInUser()
  const isAdmin = userRole === CustomerRole.ADMIN
  const hasInvoicesPermission = !!userData?.permissions?.allowZellerInvoices
  return isAdmin || hasInvoicesPermission
}
